var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_2_1",
    "data-name": "Component 2 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.801,
    height: 28.47,
    viewBox: "0 0 26.801 28.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M131.448,309.542q0,5.62,0,11.239a2.728,2.728,0,0,1-2,2.88,2.648,2.648,0,0,1-2.581-.593c-2.76-2.335-5.512-4.679-8.289-6.994a1.828,1.828,0,0,0-1.028-.371c-1.29-.055-2.587.022-3.872-.072a3.374,3.374,0,0,1-3.1-3.3q-.053-2.776,0-5.554a3.386,3.386,0,0,1,3.161-3.318c1.265-.081,2.541,0,3.809-.064a1.933,1.933,0,0,0,1.077-.41q4.094-3.406,8.142-6.868a2.763,2.763,0,0,1,4.691,2.126Q131.454,303.89,131.448,309.542Zm-3.422,10.1v-20.2c-2.488,2.11-4.923,4.13-7.3,6.214a4.069,4.069,0,0,1-3.04,1.132c-1.031-.054-2.067-.012-3.1-.008-.207,0-.413.025-.619.038v5.5c1.206,0,2.37.057,3.525-.014a4.414,4.414,0,0,1,3.384,1.251C123.19,315.614,125.587,317.579,128.026,319.645Z",
    transform: "translate(-110.54 -295.309)",
    fill: "#fcac00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M157.422,318.529a5.15,5.15,0,0,1-.9,3.049,1.24,1.24,0,1,1-2.1-1.309,3.141,3.141,0,0,0-.018-3.519,1.187,1.187,0,0,1,.375-1.734,1.217,1.217,0,0,1,1.73.432A5.136,5.136,0,0,1,157.422,318.529Z",
    transform: "translate(-130.624 -304.286)",
    fill: "#fcac00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeDown);
export default __webpack_public_path__ + "static/media/volumeDown.a38834b01f8e2a714072caec9a6bf277.svg";
export { ForwardRef as ReactComponent };